import { Component, OnInit, NgZone } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../auth.service';
import { WebPage } from '../../shared/web-page';
import { MessageService } from 'primeng/components/common/messageservice';
import { Util } from '../../shared/util';

@Component({
  template: ''
})
export class LoginComponent extends WebPage implements OnInit {

  token;
  sistema;

  constructor(private authService: AuthService, private route: ActivatedRoute, private ngZone: NgZone, messageService: MessageService) {
    super(messageService);

    this.route.queryParamMap.subscribe(queryParams => {
      this.token = queryParams.get('token');
      this.sistema = queryParams.get('sistema');
    });
  }

  ngOnInit() {
    if (this.authService.isLoggedIn()) {
      return;
    }

    this.authService.checarCredenciais(this.token, this.sistema)
      .subscribe(
        usuario => {
          const usuarioLogado = localStorage.getItem('usuarioGestao');

          if (Util.isNullOrEmptyOrUndefined(usuarioLogado)) {
            this.authService.logIn(usuario);
          }
          this.ngZone.runOutsideAngular(() => location.href = '/#/admin');
        },
        error => this.gerenciaErro(error)
      );
  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/login/login.component.ts